/**
 * The canonical football positions.
 *
 * The stored value is always the short code -- it is what measurable
 * definitions, criteria, claim matching and duplicate detection all key on.
 * The label is what a parent reads: families do not know that MIKE means the
 * middle linebacker, and a free-text box produces "Offensive Tackle", "OL" and
 * "left tackle" for what the rest of the system only recognizes as OT.
 */
export const POSITION_GROUPS = [
  {
    group: 'Offense',
    positions: [
      { code: 'QB', label: 'Quarterback' },
      { code: 'RB', label: 'Running Back' },
      { code: 'FB', label: 'Fullback' },
      { code: 'WR', label: 'Wide Receiver' },
      { code: 'TE', label: 'Tight End' },
      { code: 'OT', label: 'Offensive Tackle' },
      { code: 'OG', label: 'Offensive Guard' },
      { code: 'C',  label: 'Center' },
      { code: 'OL', label: 'Offensive Line — general' },
    ],
  },
  {
    group: 'Defense',
    positions: [
      { code: 'RE',   label: 'Defensive End — Rush' },
      { code: 'PE',   label: 'Defensive End — Power' },
      { code: 'DT',   label: 'Defensive Tackle' },
      { code: 'SAM',  label: 'Linebacker — Strong side (Sam)' },
      { code: 'MIKE', label: 'Linebacker — Middle (Mike)' },
      { code: 'WILL', label: 'Linebacker — Weak side (Will)' },
      { code: 'CB',   label: 'Cornerback' },
      { code: 'S',    label: 'Safety' },
      { code: 'DL',   label: 'Defensive Line — general' },
      { code: 'LB',   label: 'Linebacker — general' },
      { code: 'DB',   label: 'Defensive Back — general' },
    ],
  },
  {
    group: 'Other',
    positions: [
      { code: 'ATH', label: 'Athlete — position undecided' },
    ],
  },
  {
    group: 'Special Teams',
    positions: [
      { code: 'K',  label: 'Kicker' },
      { code: 'P',  label: 'Punter' },
      { code: 'LS', label: 'Long Snapper' },
      { code: 'KR', label: 'Kick Returner' },
      { code: 'PR', label: 'Punt Returner' },
    ],
  },
];

export const ALL_POSITIONS = POSITION_GROUPS.flatMap((g) => g.positions);

export const positionLabel = (code) =>
  ALL_POSITIONS.find((p) => p.code === code)?.label || code || '';
